import { cn } from "@/lib/utils";
import { Monogram } from "./Logo";

interface BrandLoaderProps {
  /** Edge length of the mark in pixels. */
  size?: number;
  /** Optional caption rendered beneath the mark. */
  label?: string;
  /** Center within the full viewport height. */
  fullscreen?: boolean;
  className?: string;
}

/**
 * Branded loading indicator: the `s.` monogram with its accent full stop
 * breathing — the landing's "line head" signal — inside a soft ring pulse.
 */
export function BrandLoader({ size = 56, label, fullscreen, className }: BrandLoaderProps) {
  return (
    <output
      className={cn(
        "flex flex-col items-center justify-center gap-3 text-muted-foreground",
        fullscreen && "h-dvh",
        className
      )}
    >
      <span className="brand-loader" style={{ width: size, height: size }}>
        <Monogram size={size} dotClassName="brand-loader__dot" />
      </span>
      {label ? (
        <span className="font-display text-sm tracking-tight text-foreground/70">{label}</span>
      ) : (
        <span className="sr-only">불러오는 중</span>
      )}
    </output>
  );
}
